import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import {
  inboxViewFetchDashboardRequest,
  inboxViewInit,
} from '../inboxViewSlice';
import { RootState } from '../../../../store';

type IN = ReturnType<typeof inboxViewInit>;
type OUT = ReturnType<typeof inboxViewFetchDashboardRequest>;

export const InboxViewOnInitEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(inboxViewInit.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return [inboxViewFetchDashboardRequest()];
    }),
  );
